/**
 * PersonFirstName
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectPersonValue } from '../../services/people/selectors';

export class PersonFirstName extends React.PureComponent {
    render() {
        return this.props.firstName;
    }
}

PersonFirstName.propTypes = {
    firstName: PropTypes.string
};

PersonFirstName.defaultProps = {
    firstName: null
};

const mapStateToProps = createStructuredSelector({
    firstName: makeSelectPersonValue('firstName')
});

export default connect(mapStateToProps)(PersonFirstName);
